export const COLORS = {
  backgroundColor: "#002F47",
  curveBG: "#024162",
  button: "#00bfa6",
};
